export default "__VITE_ASSET__ClFkbiwR__"